import { render, staticRenderFns } from "./PerformanceSummaryTable.vue?vue&type=template&id=6c238b42&scoped=true"
import script from "./PerformanceSummaryTable.vue?vue&type=script&lang=js"
export * from "./PerformanceSummaryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c238b42",
  null
  
)

export default component.exports